import { FailureResponseModel } from "../";

export class ErrorResponseModel {
    constructor(
      public Errors: FailureResponseModel[],
      public Title: string) {
    }
  }
  
